import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useSelector } from "react-redux";
import { authSelector } from "../redux/Selectors";

const GuardedRoute = ({ component: Component, auth, ...rest }) => {
  const authStore = useSelector(authSelector);
  return (
    <Route
      {...rest}
      render={(props) =>
        authStore.auth ? <Component {...props} /> : <Redirect to="/login" />
      }
    />
  );
};

export default GuardedRoute;
